module.exports = {
    menus:["baosimanager", "qiyemanager", "productmanager", "orderrecord", "orderrecord2", "authmanager", 'paymanager', 'financialcenter', 'billCenter', 'logquery', 'offlinemanager']
}